var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "188",
      "height": "41",
      "viewBox": "0 0 188 41",
      "fill": "none"
    }
  }, [_c('g', {
    attrs: {
      "clip-path": "url(#clip0_135_1479)"
    }
  }, [_c('mask', {
    staticStyle: {
      "mask-type": "luminance"
    },
    attrs: {
      "id": "mask0_135_1479",
      "maskUnits": "userSpaceOnUse",
      "x": "44",
      "y": "10",
      "width": "8",
      "height": "24"
    }
  }, [_c('path', {
    attrs: {
      "d": "M46.8717 10.158H48.9713C49.0782 10.158 49.1851 10.158 49.2309 10.2648C49.2844 10.3183 49.3378 10.4252 49.3378 10.5321V15.6476C49.3378 15.701 49.3378 15.7544 49.3913 15.8079C49.4447 15.8613 49.4982 15.8613 49.5516 15.8613H51.3382C51.4451 15.8613 51.4985 15.8613 51.5978 15.9682C51.6512 16.0217 51.7047 16.1286 51.7047 16.2355V17.7625C51.7047 17.8159 51.6512 17.9228 51.5978 18.0297C51.4909 18.0831 51.4375 18.1366 51.3382 18.1366H49.5516C49.4982 18.0831 49.4447 18.1366 49.3913 18.19C49.3378 18.19 49.3378 18.2969 49.3378 18.3504V29.6884C49.3378 30.6886 49.8112 31.2154 50.8114 31.2154H51.3382C51.4451 31.2154 51.4985 31.2689 51.5978 31.3223C51.6512 31.4292 51.7047 31.5361 51.7047 31.5895V33.5899C51.7047 33.6968 51.6512 33.8037 51.5978 33.8571C51.4909 33.964 51.4375 33.964 51.3382 33.964H50.3915C47.7116 33.964 46.5052 32.7501 46.5052 29.696V18.358C46.5052 18.3046 46.5052 18.1977 46.4518 18.1977C46.3983 18.1442 46.3449 18.0908 46.2914 18.0908H45.1844C45.0775 18.0908 44.9706 18.0908 44.9248 17.9839C44.8713 17.9304 44.8179 17.8235 44.8179 17.7701V16.1896C44.8179 16.0828 44.8179 15.9759 44.9248 15.9224C44.9782 15.869 45.0851 15.8155 45.1844 15.8155H46.2914C46.3449 15.8155 46.3983 15.8155 46.4518 15.7621C46.5052 15.7086 46.5052 15.6552 46.5052 15.6017V10.5397C46.5052 10.4328 46.5052 10.3259 46.6121 10.2725C46.6656 10.1656 46.7724 10.1656 46.8717 10.1656V10.158Z",
      "fill": "white"
    }
  })]), _c('g', {
    attrs: {
      "mask": "url(#mask0_135_1479)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M44.7188 10.158H51.7125V33.9869H44.7188V10.158Z",
      "fill": "#111111"
    }
  })]), _c('mask', {
    staticStyle: {
      "mask-type": "luminance"
    },
    attrs: {
      "id": "mask1_135_1479",
      "maskUnits": "userSpaceOnUse",
      "x": "54",
      "y": "15",
      "width": "8",
      "height": "19"
    }
  }, [_c('path', {
    attrs: {
      "d": "M60.6912 15.4796C60.9508 15.4796 61.1646 15.4796 61.4241 15.533C61.6379 15.5865 61.6837 15.7468 61.6379 15.953L61.1111 18.0602C61.0577 18.274 60.8973 18.4267 60.6912 18.3733H60.1109C58.3778 18.3733 57.0645 19.6407 57.0645 22.2748V33.3456C57.0645 33.4525 57.0645 33.5594 56.9576 33.6586C56.9042 33.7121 56.7973 33.7655 56.6981 33.7655H54.5984C54.545 33.7655 54.4381 33.7121 54.3388 33.6586C54.2854 33.5517 54.2319 33.4448 54.2319 33.3456V16.1591C54.2319 16.0522 54.2854 15.9453 54.3388 15.8919C54.4457 15.8384 54.5526 15.785 54.5984 15.785H56.6981C56.8049 15.785 56.9118 15.8384 57.0111 15.8919C57.0645 15.9453 57.118 16.0522 57.118 16.1591V17.8465C57.6982 16.3729 59.1184 15.4185 60.6912 15.472V15.4796Z",
      "fill": "white"
    }
  })]), _c('g', {
    attrs: {
      "mask": "url(#mask1_135_1479)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M54.2319 15.4261H61.6379V33.7732H54.2319V15.4261Z",
      "fill": "#111111"
    }
  })]), _c('mask', {
    staticStyle: {
      "mask-type": "luminance"
    },
    attrs: {
      "id": "mask2_135_1479",
      "maskUnits": "userSpaceOnUse",
      "x": "62",
      "y": "15",
      "width": "11",
      "height": "20"
    }
  }, [_c('path', {
    attrs: {
      "d": "M67.6849 15.4796C71.2581 15.4796 72.7774 17.1135 72.7774 21.3815V33.3532C72.7774 33.4601 72.7316 33.567 72.6705 33.6663C72.6247 33.7197 72.5178 33.7732 72.411 33.7732H70.3571C70.2502 33.7732 70.1433 33.7197 70.0975 33.6663C69.9906 33.5594 69.9906 33.4525 69.9906 33.3532V31.8262C69.4638 33.2463 68.0972 34.1473 66.6312 34.0938C64.5316 34.0938 62.4243 32.773 62.4243 28.7722C62.4243 24.7714 64.6843 23.2368 67.6772 23.2368H69.7769C69.8303 23.2368 69.8838 23.2368 69.9372 23.1833C69.9906 23.1299 69.9906 23.0765 69.9906 23.023V21.5494C69.9906 19.1215 69.3111 18.1213 67.3642 18.1213C66.2113 18.1213 65.1577 18.5947 64.3178 19.3353C64.2109 19.3887 64.104 19.4422 64.0048 19.3887C63.8444 19.3887 63.791 19.2818 63.7452 19.1749L63.0122 17.7014C62.9053 17.541 62.9588 17.2815 63.1191 17.1211C64.3789 16.014 66.0128 15.4338 67.6925 15.4872L67.6849 15.4796ZM68.0513 25.6571C65.9517 25.6571 65.1119 26.7107 65.1119 28.7188C65.1119 30.7268 65.9517 31.6201 67.3718 31.6201C68.8988 31.6201 69.9983 30.2992 69.9983 28.3523V25.8709C69.9983 25.8174 69.9448 25.764 69.9448 25.7105C69.8914 25.6571 69.8379 25.6571 69.7311 25.6571H68.0513Z",
      "fill": "white"
    }
  })]), _c('g', {
    attrs: {
      "mask": "url(#mask2_135_1479)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M62.3784 15.4261H72.8308V34.0938H62.3784V15.4261Z",
      "fill": "#111111"
    }
  })]), _c('mask', {
    staticStyle: {
      "mask-type": "luminance"
    },
    attrs: {
      "id": "mask3_135_1479",
      "maskUnits": "userSpaceOnUse",
      "x": "76",
      "y": "15",
      "width": "11",
      "height": "19"
    }
  }, [_c('path', {
    attrs: {
      "d": "M82.3976 15.4796C85.1844 15.4796 86.5969 17.2204 86.5969 20.9615V33.3532C86.6503 33.4601 86.5969 33.567 86.49 33.6663C86.4442 33.7197 86.3373 33.7731 86.2304 33.7731H84.1308C84.0239 33.7731 83.917 33.7197 83.8636 33.6663C83.7567 33.5594 83.7567 33.4525 83.7567 33.3532V21.4349C83.7567 19.3276 83.0237 18.1671 81.3974 18.1671C79.9239 18.1671 79.0306 19.2208 79.0306 21.4349V33.3532C79.0306 33.4601 78.9848 33.567 78.9237 33.6663C78.8168 33.7197 78.7099 33.7731 78.6641 33.7731H76.5645C76.4576 33.7731 76.3507 33.7197 76.2514 33.6663C76.198 33.5594 76.1445 33.4525 76.1445 33.3532V16.1667C76.1445 16.0598 76.1903 15.953 76.2514 15.8995C76.3583 15.8461 76.4652 15.7926 76.5645 15.7926H78.6641C78.7099 15.7926 78.8168 15.8461 78.9237 15.8995C78.9771 15.953 79.0306 16.0598 79.0306 16.1667V17.5869C79.6108 16.2125 80.9775 15.4261 82.39 15.4796H82.3976Z",
      "fill": "white"
    }
  })]), _c('g', {
    attrs: {
      "mask": "url(#mask3_135_1479)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M76.0913 15.4261H86.704V33.7732H76.0913V15.4261Z",
      "fill": "#111111"
    }
  })]), _c('mask', {
    staticStyle: {
      "mask-type": "luminance"
    },
    attrs: {
      "id": "mask4_135_1479",
      "maskUnits": "userSpaceOnUse",
      "x": "89",
      "y": "15",
      "width": "11",
      "height": "20"
    }
  }, [_c('path', {
    attrs: {
      "d": "M94.3766 15.4796C97.423 15.4796 98.8966 17.3273 99.1562 19.488C99.2096 19.7552 99.1104 19.9079 98.8966 19.9614L97.11 20.3278C96.8962 20.3813 96.6901 20.2209 96.6366 20.0148C96.3236 18.7474 95.7433 17.9075 94.3843 17.9075C93.0252 17.9075 92.2846 18.8543 92.2846 20.3355C92.2846 21.3891 92.7504 22.29 94.3308 22.9161L95.8578 23.4964C98.5301 24.55 99.4768 26.1839 99.4768 28.8256C99.4768 31.9331 97.6444 34.1015 94.3308 34.1015C91.3379 34.1015 89.4978 32.4676 89.1848 29.5128C89.139 29.4059 89.1848 29.299 89.2382 29.2456C89.2841 29.1387 89.391 29.0852 89.4978 29.0852L91.3913 28.7188C91.4982 28.6653 91.6051 28.6653 91.6586 28.7722C91.7655 28.8256 91.8113 28.8791 91.8113 28.986C92.0785 30.8337 93.071 31.5666 94.3919 31.5666C95.8044 31.5666 96.7511 30.7191 96.7511 28.986C96.7511 27.6117 96.2243 26.7718 94.6515 26.1381L93.1779 25.6113C90.8645 24.718 89.4978 23.1299 89.4978 20.5493C89.4978 17.5945 91.3379 15.4872 94.3843 15.4872L94.3766 15.4796Z",
      "fill": "white"
    }
  })]), _c('g', {
    attrs: {
      "mask": "url(#mask4_135_1479)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M89.1235 15.4261H99.469V34.0938H89.1235V15.4261Z",
      "fill": "#111111"
    }
  })]), _c('mask', {
    staticStyle: {
      "mask-type": "luminance"
    },
    attrs: {
      "id": "mask5_135_1479",
      "maskUnits": "userSpaceOnUse",
      "x": "102",
      "y": "15",
      "width": "11",
      "height": "26"
    }
  }, [_c('path', {
    attrs: {
      "d": "M108.456 15.4796C110.296 15.3727 111.922 16.6401 112.35 18.4343C112.663 19.4345 112.77 20.3813 112.77 24.8172C112.77 29.2532 112.663 30.1465 112.35 31.2001C111.922 32.9944 110.296 34.2618 108.456 34.1549C106.936 34.2618 105.57 33.3074 105.043 31.9407V40.1102C105.043 40.2171 104.989 40.324 104.936 40.4233C104.883 40.4767 104.776 40.5302 104.669 40.5302H102.516C102.409 40.5302 102.302 40.4767 102.248 40.4233C102.142 40.3164 102.142 40.2095 102.142 40.1102V16.1744C102.142 16.0675 102.142 15.9606 102.248 15.9071C102.302 15.8537 102.409 15.8003 102.516 15.8003H104.615C104.722 15.8003 104.768 15.8537 104.875 15.9071C104.928 15.9606 104.982 16.0675 104.982 16.1744V17.6479H105.035C105.562 16.2278 106.975 15.3269 108.448 15.4872L108.456 15.4796ZM107.463 18.1671C106.463 18.1137 105.57 18.7474 105.257 19.7476C105.096 20.3813 104.989 20.8547 104.989 24.7562C104.989 28.6577 105.096 29.1845 105.257 29.8182C105.57 30.7649 106.463 31.4521 107.463 31.3987C108.456 31.4521 109.403 30.7649 109.616 29.8182C109.83 29.1845 109.884 28.7111 109.884 24.7562C109.884 20.8012 109.83 20.3813 109.616 19.7476C109.403 18.7474 108.463 18.1137 107.463 18.1671Z",
      "fill": "white"
    }
  })]), _c('g', {
    attrs: {
      "mask": "url(#mask5_135_1479)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M102.104 15.4261H112.823V40.5225H102.104V15.4261Z",
      "fill": "#111111"
    }
  })]), _c('mask', {
    staticStyle: {
      "mask-type": "luminance"
    },
    attrs: {
      "id": "mask6_135_1479",
      "maskUnits": "userSpaceOnUse",
      "x": "115",
      "y": "15",
      "width": "11",
      "height": "20"
    }
  }, [_c('path', {
    attrs: {
      "d": "M120.595 15.4796C124.169 15.4796 125.642 17.1135 125.642 21.3815V33.3532C125.642 33.4601 125.642 33.567 125.535 33.6663C125.482 33.7197 125.375 33.7732 125.268 33.7732H123.214C123.107 33.7732 123 33.7197 122.955 33.6663C122.901 33.5594 122.848 33.4525 122.848 33.3532V31.8262C122.321 33.2463 120.954 34.1473 119.488 34.0938C117.389 34.0938 115.289 32.773 115.289 28.7722C115.289 24.7714 117.541 23.2368 120.542 23.2368H122.642C122.687 23.2368 122.794 23.2368 122.794 23.1833C122.848 23.1299 122.901 23.0765 122.848 23.023V21.5494C122.848 19.1215 122.161 18.1213 120.221 18.1213C119.114 18.1213 118.015 18.5947 117.175 19.3353C117.121 19.3887 116.961 19.4422 116.862 19.3887C116.755 19.3887 116.648 19.2818 116.595 19.1749L115.915 17.7014C115.755 17.541 115.808 17.2815 115.961 17.1211C117.274 16.014 118.9 15.4338 120.58 15.4872L120.595 15.4796ZM120.97 25.6571C118.87 25.6571 118.03 26.7107 118.03 28.7188C118.03 30.7268 118.816 31.6201 120.237 31.6201C121.756 31.6201 122.863 30.2992 122.863 28.3523V25.8709C122.863 25.8174 122.863 25.764 122.81 25.7105C122.764 25.6571 122.703 25.6571 122.657 25.6571H120.977H120.97Z",
      "fill": "white"
    }
  })]), _c('g', {
    attrs: {
      "mask": "url(#mask6_135_1479)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M115.297 15.4261H125.696V34.0938H115.297V15.4261Z",
      "fill": "#111111"
    }
  })]), _c('mask', {
    staticStyle: {
      "mask-type": "luminance"
    },
    attrs: {
      "id": "mask7_135_1479",
      "maskUnits": "userSpaceOnUse",
      "x": "129",
      "y": "15",
      "width": "8",
      "height": "19"
    }
  }, [_c('path', {
    attrs: {
      "d": "M135.469 15.4796C135.736 15.4796 135.942 15.4796 136.201 15.533C136.415 15.5865 136.469 15.7468 136.415 15.953L135.888 18.0602C135.843 18.274 135.675 18.4267 135.423 18.3733H134.896C133.109 18.3733 131.85 19.6407 131.85 22.2748V33.3456C131.85 33.4525 131.85 33.5594 131.743 33.6586C131.689 33.7121 131.582 33.7655 131.475 33.7655H129.376C129.33 33.7655 129.223 33.7121 129.116 33.6586C129.063 33.5517 129.009 33.4448 129.009 33.3456V16.1591C129.009 16.0522 129.055 15.9453 129.116 15.8919C129.223 15.8384 129.33 15.785 129.376 15.785H131.475C131.582 15.785 131.689 15.8384 131.788 15.8919C131.842 15.9453 131.895 16.0522 131.842 16.1591V17.8465H131.888C132.468 16.3729 133.88 15.4185 135.461 15.472L135.469 15.4796Z",
      "fill": "white"
    }
  })]), _c('g', {
    attrs: {
      "mask": "url(#mask7_135_1479)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M129.009 15.4261H136.469V33.7732H129.009V15.4261Z",
      "fill": "#111111"
    }
  })]), _c('mask', {
    staticStyle: {
      "mask-type": "luminance"
    },
    attrs: {
      "id": "mask8_135_1479",
      "maskUnits": "userSpaceOnUse",
      "x": "137",
      "y": "15",
      "width": "11",
      "height": "20"
    }
  }, [_c('path', {
    attrs: {
      "d": "M142.561 15.4796C145.081 15.4796 146.661 16.6401 147.394 18.8008C147.662 19.6483 147.814 20.5951 147.814 25.283C147.814 25.3899 147.768 25.4968 147.707 25.5502C147.6 25.6037 147.494 25.6571 147.394 25.6571H140.408C140.355 25.6571 140.301 25.6571 140.248 25.7105C140.202 25.764 140.202 25.8174 140.202 25.8709C140.202 28.7722 140.309 29.4059 140.462 29.8793C140.729 30.7726 141.569 31.4063 142.561 31.4063C143.821 31.4063 144.554 30.7726 144.928 29.3525C144.974 29.2456 145.035 29.1921 145.081 29.0852C145.188 29.0318 145.295 29.0318 145.394 29.0852L147.387 29.4517C147.6 29.5052 147.654 29.7189 147.6 29.9251C147.234 32.4065 145.027 34.1931 142.508 34.0938C140.034 34.0938 138.408 32.8799 137.721 30.7191C137.461 29.8716 137.301 28.9783 137.301 24.7638C137.301 20.5493 137.461 19.6483 137.721 18.8085C138.408 16.7012 140.034 15.4872 142.554 15.4872L142.561 15.4796ZM142.561 18.0679C141.615 18.0679 140.775 18.7016 140.462 19.5949C140.309 20.0682 140.202 20.6485 140.202 22.9696C140.202 23.023 140.202 23.1299 140.248 23.1299C140.301 23.1833 140.355 23.2368 140.408 23.2368H144.714C144.76 23.2368 144.821 23.1833 144.867 23.1299C144.921 23.1299 144.921 23.0765 144.921 23.023V22.9696C144.921 20.6485 144.814 20.0682 144.653 19.5949C144.34 18.7016 143.5 18.0679 142.554 18.0679H142.561Z",
      "fill": "white"
    }
  })]), _c('g', {
    attrs: {
      "mask": "url(#mask8_135_1479)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M137.209 15.4261H147.814V34.0938H137.209V15.4261Z",
      "fill": "#111111"
    }
  })]), _c('mask', {
    staticStyle: {
      "mask-type": "luminance"
    },
    attrs: {
      "id": "mask9_135_1479",
      "maskUnits": "userSpaceOnUse",
      "x": "150",
      "y": "15",
      "width": "12",
      "height": "19"
    }
  }, [_c('path', {
    attrs: {
      "d": "M157.068 15.4796C159.847 15.4796 161.267 17.2204 161.267 20.9615V33.3532C161.267 33.4601 161.267 33.567 161.161 33.6663C161.107 33.7197 161 33.7731 160.893 33.7731H158.794C158.687 33.7731 158.58 33.7197 158.534 33.6663C158.427 33.5594 158.427 33.4525 158.427 33.3532V21.4349C158.427 19.3276 157.633 18.1671 156.06 18.1671C154.488 18.1671 153.64 19.2208 153.64 21.4349V33.3532C153.693 33.4601 153.64 33.567 153.533 33.6663C153.487 33.7197 153.38 33.7731 153.274 33.7731H151.174C151.067 33.7731 151.014 33.7197 150.907 33.6663C150.861 33.5594 150.8 33.4525 150.8 33.3532V16.1667C150.8 16.0598 150.853 15.953 150.907 15.8995C151.014 15.8461 151.067 15.7926 151.174 15.7926H153.274C153.38 15.7926 153.487 15.8461 153.533 15.8995C153.64 15.953 153.693 16.0598 153.64 16.1667V17.5869C154.274 16.2125 155.587 15.4261 157.061 15.4796H157.068Z",
      "fill": "white"
    }
  })]), _c('g', {
    attrs: {
      "mask": "url(#mask9_135_1479)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M150.769 15.4261H161.275V33.7732H150.769V15.4261Z",
      "fill": "#111111"
    }
  })]), _c('mask', {
    staticStyle: {
      "mask-type": "luminance"
    },
    attrs: {
      "id": "mask10_135_1479",
      "maskUnits": "userSpaceOnUse",
      "x": "164",
      "y": "15",
      "width": "11",
      "height": "20"
    }
  }, [_c('path', {
    attrs: {
      "d": "M169.421 15.4796C170.681 15.3727 171.941 15.8461 172.888 16.6936C173.835 17.5869 174.415 18.8008 174.415 20.0683C174.415 20.282 174.415 20.4347 174.148 20.4882L172.155 20.8547C172.048 20.9081 171.941 20.9081 171.842 20.8012C171.788 20.7478 171.735 20.6409 171.735 20.534C171.468 18.8466 170.681 18.1595 169.421 18.1595C168.475 18.0526 167.581 18.6863 167.322 19.6331C167.108 20.3202 167.108 20.6867 167.108 24.7485C167.108 28.8104 167.108 29.2303 167.322 29.9175C167.581 30.8642 168.475 31.4445 169.421 31.391C170.681 31.391 171.468 30.6504 171.735 28.9631C171.735 28.8562 171.781 28.7493 171.842 28.6959C171.949 28.6424 172.056 28.6424 172.155 28.6959L174.148 29.0623C174.415 29.1158 174.415 29.2227 174.415 29.4823C174.415 30.7497 173.835 31.9637 172.888 32.8035C171.941 33.6968 170.681 34.1244 169.421 34.0709C166.948 34.0709 165.375 32.9104 164.634 30.7497C164.268 29.696 164.214 29.0623 164.214 24.7409C164.214 20.4195 164.268 19.8392 164.634 18.7856C165.321 16.6249 166.948 15.4643 169.421 15.4643V15.4796Z",
      "fill": "white"
    }
  })]), _c('g', {
    attrs: {
      "mask": "url(#mask10_135_1479)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M164.107 15.4261H174.461V34.0938H164.107V15.4261Z",
      "fill": "#111111"
    }
  })]), _c('mask', {
    staticStyle: {
      "mask-type": "luminance"
    },
    attrs: {
      "id": "mask11_135_1479",
      "maskUnits": "userSpaceOnUse",
      "x": "175",
      "y": "15",
      "width": "13",
      "height": "26"
    }
  }, [_c('path', {
    attrs: {
      "d": "M175.988 15.8002H178.194C178.454 15.8002 178.561 15.9606 178.561 16.1667L181.348 28.4515H181.393L184.18 16.1667C184.18 16.0598 184.226 15.9529 184.287 15.8995C184.394 15.8461 184.501 15.7926 184.6 15.7926H186.753C186.967 15.7926 187.074 15.9529 187.02 16.1591L182.134 35.5597C181.141 39.5681 180.034 40.4614 177.408 40.4614L176.988 40.5149C176.881 40.5149 176.774 40.4614 176.728 40.408C176.621 40.3011 176.621 40.1942 176.621 40.095V38.0946C176.621 37.9877 176.621 37.8808 176.728 37.8274C176.774 37.7739 176.881 37.7205 176.988 37.7205L177.408 37.667C178.461 37.667 178.981 37.1936 179.355 35.6132L180.034 33.1852L175.675 16.1515C175.621 16.0446 175.675 15.9911 175.72 15.8842C175.774 15.8308 175.881 15.7773 175.988 15.7773V15.8002Z",
      "fill": "white"
    }
  })]), _c('g', {
    attrs: {
      "mask": "url(#mask11_135_1479)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M175.675 15.8003H187.082V40.5225H175.675V15.8003Z",
      "fill": "#111111"
    }
  })]), _c('mask', {
    staticStyle: {
      "mask-type": "luminance"
    },
    attrs: {
      "id": "mask12_135_1479",
      "maskUnits": "userSpaceOnUse",
      "x": "0",
      "y": "0",
      "width": "40",
      "height": "41"
    }
  }, [_c('path', {
    attrs: {
      "d": "M6.46688 0.980637H12.9796V7.36353H6.46688V0.980637ZM19.4923 0.980637H39.038V13.8991H26.005V7.36353H19.4923V0.980637ZM0 7.36353H6.46688V13.8991H0V7.36353ZM12.9796 7.36353H19.4923V13.8991H12.9796V7.36353ZM19.4923 13.8991H25.9592V31.7728C25.9057 33.1471 25.1193 34.4069 23.8595 35.094L23.7526 35.1475L23.6457 35.2009L23.4854 35.3078L23.3251 35.3612L23.0655 35.4147L22.9051 35.4681H22.7982L22.4852 35.5216H22.0653C21.5385 35.5216 21.0116 35.3612 20.4848 35.1551C19.0647 34.5748 18.118 33.1013 18.118 31.5208C18.118 31.4139 18.0111 31.307 17.8584 31.307C17.6446 31.307 17.385 31.7804 17.385 31.7804L13.0254 39.7972C12.9719 39.8507 12.9719 39.9575 12.9719 40.0644V20.3966H19.4846V13.9144L19.4923 13.8991Z",
      "fill": "white"
    }
  })]), _c('g', {
    attrs: {
      "mask": "url(#mask12_135_1479)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0 0.927185H39.0456V40.4233H0V0.927185Z",
      "fill": "#111111"
    }
  })]), _c('mask', {
    staticStyle: {
      "mask-type": "luminance"
    },
    attrs: {
      "id": "mask13_135_1479",
      "maskUnits": "userSpaceOnUse",
      "x": "12",
      "y": "31",
      "width": "12",
      "height": "10"
    }
  }, [_c('path', {
    attrs: {
      "d": "M17.866 31.2994C18.0263 31.2994 18.1256 31.4063 18.1256 31.5666C18.1256 33.7274 19.8587 35.5216 22.0652 35.5216L23.8137 35.1246L18.576 37.8808C16.6367 38.9192 14.7356 39.9041 13.4987 40.3775C13.3918 40.4309 13.1857 40.3775 13.0788 40.2706C12.9719 40.1637 12.9719 39.9575 13.0253 39.8507L17.385 31.7804C17.385 31.7804 17.6445 31.307 17.8583 31.307L17.866 31.2994ZM23.8595 35.094H23.9129L23.8213 35.1169L23.8595 35.094Z",
      "fill": "white"
    }
  })]), _c('g', {
    attrs: {
      "mask": "url(#mask13_135_1479)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M12.9795 31.2994H23.9129V40.4233H12.9795V31.2994Z",
      "fill": "#BBBBBB"
    }
  })])]), _c('defs', [_c('clipPath', {
    attrs: {
      "id": "clip0_135_1479"
    }
  }, [_c('rect', {
    attrs: {
      "width": "187.089",
      "height": "40",
      "fill": "white",
      "transform": "translate(0 0.927185)"
    }
  })])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }